module.exports = __webpack_public_path__ + "static/media/dashboard-play.c933052c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard-play.svg
// module id = 626
// module chunks = 31